<template>
  <div class="tags" v-if="showTags">
    <ul>
      <transition-group tag="li" name="breadcrumb">
        <li
          class="tags-li"
          v-for="(item,index) in tagsList"
          :class="{'active': isActive(item.path)}"
          :key="'target_li_'+index"
        >
          <router-link :to="item.path" @click.native="refreshDot(item.path)" class="tags-li-title">{{
              $t(item.title)
            }}
          </router-link>
          <span class="tags-li-icon" @click="closeTags(index)">
                    <i :style="isActive(item.path)?'color:#FFF':'color:#FF6B0D'" class="el-icon-close"></i>
                </span>
        </li>
      </transition-group>
    </ul>

    <!--    右侧关闭全部-->
    <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <el-button size="mini" type="primary">
          {{ $t('store.labelOptions') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu size="small">
            <el-dropdown-item command="other">{{ $t('store.labelCloseOther') }}</el-dropdown-item>
            <el-dropdown-item command="all">{{ $t('store.labelCloseAll') }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    tagsList() {
      return this.$store.state.tagsList;
    },
    showTags() {
      return this.tagsList.length > 0;
    }
  },
  methods: {
    async refreshDot(url) {
      // 匹配到包含order的路由才调用统计订单数量的接口
      if (url.lastIndexOf('-order') !== -1) {
        await this.$store.dispatch('total_order_count')
      }
    },
    isActive(path) {
      return path === this.$route.fullPath;
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList[index];
      this.$store.commit("delTagsItem", {index});
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push("/");
      }
    },
    // 关闭全部标签
    closeAll() {
      this.$store.commit("clearTags");
      // 关闭所有标签需要跳转到待接单
      this.$router.push("/");
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter(item => {
        return item.path === this.$route.fullPath;
      });
      this.$store.commit("closeTagsOther", curItem);
    },
    // 设置标签
    setTags(route) {
      // 不是从redirect过的路由代表列表中已存在
      if (route.fullPath.toString().lastIndexOf('redirect') !== -1) return false
      const isExist = this.tagsList.some(item => {
        return item.path === route.fullPath;
      });
      if (!isExist) {
        if (this.tagsList.length >= 8) {
          this.$store.commit("delTagsItem", {index: 0});
        }
        this.$store.commit("setTagsItem", {
          name: route.name,
          title: route.meta.title,
          path: route.fullPath,
          noCache: route.meta?.noCache
        });
      }
    },
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    }
  },
  watch: {
    $route(newValue) {
      this.setTags(newValue);
    }
  },
  created() {
    this.setTags(this.$route);
  }
};
</script>

<style>
.tags {
  position: relative;
  height: 34px;
  line-height: 29px;
  overflow: hidden;
  background: #fff;
  padding-right: 120px;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.tags-li {
  border-radius: 2px;
  display: inline-block;
  margin: 2px 8px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 26px;
  line-height: 26px;
  border: 1px solid #FF6B0D;
  background: #fff;
  padding: 0 5px 0 12px;
  vertical-align: middle;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

/*.tags-li:not(.active):hover {
  background: #f8f8f8;
}*/
.tags-li.active {
  color: #fff;
  border: 1px solid #FF6B0D;
  background-color: #FF6B0D;
}

.tags-li-title {
  float: left;
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 5px;
  color: #FF6B0D;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

.tags-close-box {
  position: absolute;
  right: 5px;
  top: 0;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 110px;
  height: 26px;
  /*background: #fff;*/
  /*box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);*/
  z-index: 10;
}

.tags-close-box .el-button--primary {
  height: 26px;
  border-radius: 2px;
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all .5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all .5s;
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>
